export const queryKeys = {
  order: 'order',
  usrhash: 'usrhash',
  nw: {
    tips: 'nnworld-tips',
    user: 'nnworld-user',
    races: 'nnworld-races',
    equipment: 'nnworld-equipment',
  },
  product: {
    live: 'product-live',
    sheet: 'product-sheet',
  },
  stores: {
    all: 'stores-all',
  },
  search: 'search',
  event: 'event',
} as const;
